module.exports = __webpack_public_path__ + "static/media/screen-individual-04.678805c3.jpg";